module.exports = __webpack_public_path__ + "media/components/resources/show/resource-show-native-ad/img/version1-ddd38ffff9c8d9f20c10fd2850a81afe.jpg";